import Box from "components/Box";
import ContentSeparator from "components/ContentSeparator";
import Image from "components/Image";
import SanitizeHtml from "components/SanitizeHtml";
import Stack from "components/Stack";
import Text from "components/Text";

import CommunityAmenitiesTable from "entities/Deal/components/OverviewCommunityAmenities/CommunityAmenitiesTable";
import NoContent from "entities/Deal/components/OverviewSections/NoContent";
import { useDealCommunityAmenitiesManager } from "entities/Memo/utils";

interface IPrintableOverviewCommunityAmenities {
  dealId: number;
  externalToken?: string;
  displayImage?: boolean;
}

const PrintableOverviewCommunityAmenities = ({
  dealId,
  externalToken,
  displayImage = true,
}: IPrintableOverviewCommunityAmenities) => {
  const { data: communityAmenities } = useDealCommunityAmenitiesManager({
    dealId,
    token: externalToken,
  });

  if (!communityAmenities) {
    return null;
  }

  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between">
        <Text variant="h2" data-testid="section-header-name">
          Community Amenities
        </Text>
      </Stack>
      <ContentSeparator label="Community Amenities" />
      <CommunityAmenitiesTable
        community_amenities_data={communityAmenities}
        tableDataTestid="community-amenities-categories-tables"
      />

      {displayImage && communityAmenities.image && (
        <Stack spacing={2}>
          <Image
            src={communityAmenities.image}
            imgix
            imgixHeight={920}
            sx={{ height: "460px", width: "100%", objectFit: "cover" }}
            imageDataTestid="uploaded-community-amenities-image"
          />
        </Stack>
      )}
      <ContentSeparator label="Community Amenities Description" />
      <Box
        sx={{
          paddingLeft: 1,
          "*": { lineHeight: "140% !important" },
          table: {
            width: "100%",
          },
          "table, th, td, tr": {
            borderCollapse: "collapse",
            border: "1px solid black !important",
          },
        }}
        data-testid="community-amenities-description"
      >
        {communityAmenities.description && (
          <SanitizeHtml
            html={communityAmenities.description}
            dataTestid="community-amenities-description-added"
          />
        )}
        {!communityAmenities.description && <NoContent />}
      </Box>
    </Stack>
  );
};

export default PrintableOverviewCommunityAmenities;
